import { useTenantTheme } from 'lib/hooks/useTenantTheme';
import { CheckMark } from '../../../assets/icons/checkmark';

export type Props = {
  id: string;
  isChecked: boolean;
  isEnabled?: boolean;
  isRequired?: boolean;
  toggleChecked: () => void;
};

function Checkbox({
  id,
  isChecked = false,
  toggleChecked,
  isEnabled = true,
  isRequired = false,
}: Props) {
  const theme = useTenantTheme();

  return (
    <label
      data-testid="checkbox"
      className={
        'h-6 w-6 min-h-[1.5rem] min-w-[1.5rem] flex justify-center items-center rounded-md transition duration-200 focus-within:ring-2 focus-within:ring-teal-900 focus-within:ring-offset-2' +
        (isEnabled ? ' cursor-pointer' : ' bg-light-800') +
        (isChecked
          ? ` bg-teal-900 border-teal-900 ${theme.shadow[800]}`
          : ' bg-light-600 border border-light-900')
      }
    >
      <input
        data-testid="checkbox__input"
        className="sr-only"
        id={id}
        type="checkbox"
        checked={isChecked}
        disabled={!isEnabled}
        required={isRequired}
        onChange={toggleChecked}
      />
      <div className="w-3.5 h-3.5 z-10">
        <CheckMark color={isEnabled ? '#fff' : '#E8E8E8'} />
      </div>
    </label>
  );
}

export { Checkbox };
